import { Component } from 'react';

import service from '../../core/service';


interface IProps {
    dispatch?: any,
}
interface IState {
    active?: number;
    loading?:boolean;
   
  policiesList?:any;
}

export class InsurancePolicyListController extends Component<IProps, IState> {
    state: IState = {
        active: 1,
        loading:false,
        
        policiesList:[]
    };
   

    getList = async () => {
        const {
          } = this.state;
    
        this.setState({ loading: true })
        try {
          const response = await service.Policies.list();
          if (response) {
            this.setState({policiesList:response?.data?.data})
            this.setState({ loading: false })
          } else {
            this.setState({ loading: false })
          }
        } catch (error) {
          // throw error;
        }
      };
    
}
export default InsurancePolicyListController;
